import React, { memo } from "react"
import { useStore } from "../../teafuljs/store"
import GetSegment from "../../scripts/NavigateToSegment"

const Paragraph = memo(({ content, index }) => {
  const language = useStore.language()[0]
  const version = useStore.version()[0]
  const [history, setHistory] = useStore.history()
  const [searchID, setSearchID] = useStore.searchID()
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID()
  const [refID, setRefID] = useStore.refID()
  const [currentBook, setCurrentBook] = useStore.currentBook()
  const styles = {
    paragraph: {
      margin: "5px 0",
    },
    link: {
      textDecoration: "underline",
      color: "blue",
    },
  }

  const navigateToRef = obj => {
    setHistory([
      {
        page: window.location.pathname,
        language: language,
        version: version,
        segment: currentSegmentID,
        scrollY: window.scrollY,
      },
      ...history,
    ])
    const segment = GetSegment(obj.book, obj.chapter, obj.verse)
    setCurrentSegmentID(segment)
    setCurrentBook(obj.book)
    setRefID("")
    setSearchID(`${obj.book}-${obj.chapter}-${obj.verse}`)
  }

  return (
    <div style={styles.paragraph}>
      {content.map((leaf, lIndex) => {
        const { link, smallcaps } = leaf
        let styleObj = {}
        if (link) {
          styleObj = styles.link
        }
        if (smallcaps) {
          styleObj = { ...styleObj, ...{ fontVariant: 'small-caps' } }
        }
        return (
          <span
            key={`ParagraphLeaf-${index}-${lIndex}`}
            style={styleObj}
            onClick={link ? () => navigateToRef(link) : () => {}}
          >
            {leaf.text}
          </span>
        )
      })}
    </div>
  )
})

export default Paragraph
